import { combineReducers } from "redux";

// Reducers
import userReducer from "./user-reducer";

// Combine Reducers
var rootReducer = combineReducers({
  user: userReducer,
});

export default rootReducer;
